/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantRequest } from '../../models/item-variant-request';

export interface ItemVariantsPost$Params {
  'Active-Tenant-Identifier': string;
      body: ItemVariantRequest
}

export function itemVariantsPost(http: HttpClient, rootUrl: string, params: ItemVariantsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantsPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      'itemVariantId'?: string;
      }>;
    })
  );
}

itemVariantsPost.PATH = '/item-variants';
